import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.benutzer-push-notification';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungBenutzerPushNotificationEffects {

    BenutzerPushNotification$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_BENUTZER_PUSH_NOTIFICATION),
        mergeMap((x: ac.GetBenutzerPushNotificationAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getBenutzerPushNotification().pipe(
                map((result: any) => {
                    return new ac.GetBenutzerPushNotificationErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetBenutzerPushNotificationFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungQueryService);
        }
        return this.service;
    }
}
